import React from "react"
import { useFlags } from "launchdarkly-react-client-sdk"
import { Sidebar } from "ksc-portal-common-components/shadcn"
import { excludedModules } from "../../utils/utils"
import { SidebarProps } from "./types"
import filterSidebarData from "./utils"
import SidebarContent from "../components/SidebarContent"
import { sideBarItems } from "./constants"

export const SideBar = ({
  history,
  moduleData,
  sourceUrl,
  availableModules,
  openSidebar,
  closeSidebar,
}: SidebarProps) => {
  // this useEffect is there to handle legacy code that use openSidebar and closeSidebar

  const flags = useFlags()

  const modules =
    availableModules &&
    moduleData.filter(({ path }) =>
      excludedModules({
        path,
        availableModules,
        flags: flags as any,
      })
    )

  const availablePaths = modules?.map((module) => module.path)
  const filteredSidebarData = filterSidebarData(sideBarItems, availablePaths)
  return (
    <Sidebar
      side="left"
      variant="sidebar"
      collapsible="offcanvas"
      className="bg-white"
    >
      <SidebarContent
        history={history}
        sourceUrl={sourceUrl}
        sidebarData={filteredSidebarData}
        openSidebar={openSidebar}
        closeSidebar={closeSidebar}
      />
    </Sidebar>
  )
}

export default SideBar
